<template>
  <section>
    <crear-actualizar-rol />
    <ver-asignar-recursos />
    <v-card>
      <v-card-title>
         <v-toolbar-title>{{
           sistemSelected === 0 ? 'Selecciona un rol de sistema' : `Roles del sistema`
          }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-autocomplete
          :items="sistemas"
          item-text="descripcion"
          :item-value="val => parseInt(val.id)"
          label="Sistemas"     
          :loading="sistemas === undefined"
          @change="obtenerRoles"
        >
        </v-autocomplete>
        <v-tooltip bottom>
          <v-btn color="primary" dark
            @click.native.stop="crearActualizarRol({})"
            :disabled="sistemSelected === 0"
            slot="activator"
          ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
          <span>Agregar rol</span>
        </v-tooltip>             
      </v-card-title>

      <v-card-text>
        <v-data-table
          class="elevation-1"
          no-data-text='Seleccione un sistema para ver los roles'
          item-key="roles-by-sistem"
          noResultsText="No se encontraron registros que coincidan"
          noDataText="No hay resultados"
          :headers="headers"
          :items="roles"          
          rows-per-page-text='Filas por página'
          :rows-per-page-items="[5, 10, 25]"
          :rowsPerPageText="$t('common.rowsPage')"
        >
          <template slot="items" slot-scope="items">
            <td class="text-xs-center">{{ items.item.descripcion }}</td>
            <td title="Activar/Desactivar rol" align="center">
              <v-layout>
                <v-flex class="text-xs-center">
                  <v-switch
                    value
                    :input-value="items.item.id_estado === '1' ? true : false"
                    @change="cambiarEstado(items.item)"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </td>
            <td class="text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  @click.native="crearActualizarRol(items.item)"
                  color="primary">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <!-- <v-tooltip bottom>
                <v-btn
                  icon
                  colot="info"
                  slot="activator"
                  @click.native="verAsignarRecursos(items.item)"
                  color="blue"
                  dark>
                  <v-icon>list</v-icon>
                </v-btn>
                <span>Ver/Asignar recursos</span>
              </v-tooltip> -->
              <v-tooltip bottom>
                <v-btn
                  icon
                  color="error"
                  slot="activator"
                  @click.native="eliminarRol(items.item.id, 'rol')"
                  dark>
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar rol</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>

import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import LogDatos from '@/components/admin/usuario/LogDatos';
import logDatos from '@/components/admin/usuario/mixins/log-datos';
import CrearActualizarRol from '../dialogs/CrearActualizarRol.vue';
import VerAsignarRecursos from '../dialogs/VerAsignarRecursos.vue';

export default {
  mixins: [ crud, validate, logDatos ],
  data () {
    return {
      logDatos: null,
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'roles',
      headers: [
        { text: this.$t('rol.crud.description'), value: 'descripcion', align: 'center', sortable: false },
        { text: 'Estado', value: 'id_estado', align: 'center', sortable: false },
        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
      form: {
        nombre: '',
        path: '',
        descripcion: ''
      },
      dataGraphql: `
        id
        descripcion
        id_estado
        id_sistema
        recursos{
          id
          descripcion
          icono
        }
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      filters: [
        {
          field: 'descripcion',
          label: 'Nombre del rol',
          type: 'text',
          typeG: 'String',
        },
      ],
      valid: true,
      sistemas: undefined,
      roles: [],
      sistemSelected: 0
    };
  },
  mounted(){
    this.obtenerSistemas()
    this.$bus.$on('closeDialog', () => {
      this.obtenerRoles(this.sistemSelected) 
    })
  },
  methods: {
    crearActualizarRol (item) {
      if(!item.id_sistema)
        item.id_sistema = parseInt(this.sistemSelected)
      this.$bus.$emit('openDialogCrearActualizarRol', item)
    },
    eliminarRol(id, entidad){
      this.deleteItem(id, entidad,'btn-refresh-list', () => this.obtenerRoles(this.sistemSelected))
    },
    verAsignarRecursos (item) {
      this.$bus.$emit('openDialogVerAsignarRecursos', item)
    },
    async cambiarEstado (item) {
      let value = parseInt(item.id_estado) === 20 ? 1 : 20
      let data = {
        id_estado: value
      }
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: Int!, $rol: EditRol!) {
              rolEdit(id: $id, rol: $rol) {
                id
              }
            }
          `,
          variables: {
            id: parseInt(item.id),
            rol: data
          }
        })
        if (value === 1) {
          this.$message.success('Rol habilitado')
        } else {
          this.$message.warning('Rol deshabilitado')
        }
        this.obtenerRoles(this.sistemSelected)
      } catch (error) {
        console.log(error)
      }

    },
    async obtenerSistemas(){
      try {
        this.loading = true
        let res = await this.$service.graphql({
          query: `
            query{
              sistemas{
                rows{
                  id
                  descripcion
                }
              }
            }
          `
        })
        this.sistemas = res.sistemas.rows
        this.loading = false
      } catch (error) {
        console.log(error)
        this.sistemas(null)
      }
    },
    async obtenerRoles(idSistem){
      this.sistemSelected = idSistem
      try {
        this.loading = true
        let res = await this.$service.graphql({
          query: `
            query{
              roles(id_sistema: ${parseInt(idSistem)}){
                rows{
                  id
                  descripcion
                  id_estado
                }
              }
            }
          `
        })
        this.roles = res.roles.rows
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    }
  },
  components: {
    LogDatos,
    CrearActualizarRol,
    VerAsignarRecursos
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/rol-recurso/components/Rol.vue